import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	paper: {
		padding: theme.spacing.unit + 4,
		margin: "12px 0",
		'& .content-status': {
			display: 'block',
			float:'right'
		},
		'& .content-preview': {
			display: 'none',
			float:'right'
		},
		'&:hover .content-status': {
			display: 'none',
			float:'right'
		},
		'&:hover .content-preview': {
			display: 'block',
		}
	},
	checkbox: {
		padding: theme.spacing.unit / 4
	},
	favourite: {
		padding: theme.spacing.unit / 4
	},
	favouriteIcon: {
		fontSize: theme.spacing.unit * 3
	},
	textEllipsis: {
		width: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		paddingRight: theme.spacing.unit
	},
	title: {
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	concept: {
		opacity: 0.8,
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	contentTypeIcon: {
		display: 'inline-block',
		verticalAlign: 'top',
		marginRight: theme.spacing.unit + 4
	},
	subTitle: {
		display: 'inline-block',
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	contentType: {
		fontSize: theme.spacing.unit + 8,
		padding: '5px 10px',
		fontWeight:'bold',
		height:'auto !important',

	},
	contentProgress: {
		display: 'inline-block',
		width: '75px',
		height: '12px',
		borderRadius: '5px',
		background: theme.palette.background.default,
		marginRight: '2px',
		'& span': {
			background: '#EB4F4F',
			borderRadius: '5px',
			display: 'block',
			height: '100%'
		}
	},
	statusButton: {
		color: '#fff',
		padding: '3px 8px',
		display: 'inline-block',
		fontSize: '13px',
		borderRadius: '14px',
		marginRight: '3px',
		position:'relative',
		top:'-18px',
		
	},
	publishButton: {
		background: '#FF830F',
	},
	inReviewButton: {
		background: '#B3B4B3',
	},
	liveButton: {
		background: '#8ECE30',
	},
	plannedButton: {
		background: '#FF830F',
	},
	deleteButton: {
		background: '#CCCCCC',
	},
	previewButton: {
		background: theme.palette.common.white,
		border: '1px solid #DDDDDD',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
		padding: theme.spacing.unit,
		paddingTop: 2,
		height:'auto !important',
		fontSize:'16px',
    	color:'#666666',
		'& svg': {
			marginRight: theme.spacing.unit
		}
	},
	statusText: {
		fontSize: '13px',
		textTransform: 'capitalize',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
	},
	viewDetails: {
		opacity: 0.7,
		fontSize: '14px',
		paddingLeft: '12px',
		color: theme.palette.text.secondary,
	},
	assigment: {
		color:"#fff",
		fontSize: '12px',
		paddingLeft: '12px',
		background: '#FF7878',
		marginTop: "-36px",
        marginRight: "-27px",
		padding: "3px",
		float:"right"
	},
	btnSchedule: {
		'& img': {
			marginRight: theme.spacing.unit / 2,
		}
	},
});